/**
 * Created by jv on 15/05/2018.
 */
import CONSTANTS from "Sources/games/carrot-game/config/constants";

import Rabbit from "Sources/games/carrot-game/objects/rabbit";
import Carrot from "Sources/games/carrot-game/objects/carrot";
import Obstacle from "Sources/games/carrot-game/objects/obstacle";
import PowerUp from "Sources/games/carrot-game/objects/powerup";

export default class Track extends Phaser.Scene
{
  constructor()
  {
    super({
      key: "Track",
      physics:
      {
        default: "arcade",
        arcade: {
          // springbal: 300
          gravity: { y: 650 },
          debug: CONSTANTS.DEBUG
        }
      }
    });

    this.trackSpeed = 1;
    this.carrotsMissed = 0;
    this.obstaclesAvoided = 0;
    this.powerUpsMissed = 0;
    this._paused = false;

    this.minCarrotSpacing = 200;
    this.minObstacleSpacing = 200;

    this.rabbit = null;

    this.carrots = null;
    this.obstacles = null;
    this.powerUps = null;
  }

  init()
  {
    this.paused = false;

    // this.trackSpeed = 5.5;
    this.trackSpeed = 0.33;

    this.carrotSpawnRate = 1.33 * 1000;
    this.obstacleSpawnRate = { min: 2.75 * 1000, max: 4 * 1000};
    this.powerUpSpawnRate = { min: 35 * 1000, max: 55 * 1000 };

    var gameWidth = this.sys.game.config.width;
    var gameHeight = this.sys.game.config.height;

    this.carrotsMissed = 0;
    this.obstaclesAvoided = 0;
    this.powerUpsMissed = 0;

    this.rabbitPosition = {
      x: 200,
      y: gameHeight - 130
    };

    this.spawnLocation = {
      x: gameWidth + 300,
      y: gameHeight - 110
    };

    this.despawnLocation = {
      x: -300
    };

    this.spawnAllowed = true;

    this.obstacleSpawnTimer = null;
    this.carrotSpawnTimer = null;
    this.powerUpSpawnTimer = null;
    this.powerUpTimer = null;

    this.physics.world.setBounds(0, -150, gameWidth, gameHeight + 20);
  }

  create()
  {
    this.createRabbit(this.rabbitPosition.x, this.rabbitPosition.y);
    this.rabbit.startRunning();

    this.carrots = this.physics.add.group();
    this.obstacles = this.physics.add.group();
    this.powerUps = this.physics.add.group();

    // https://photonstorm.github.io/phaser3-docs/physics_arcade_World.js.html#line-1348
    this.physics.add.overlap(this.rabbit.sprite, this.carrots, this.collectCarrot, null, this);
    this.physics.add.overlap(this.rabbit.sprite, this.powerUps, this.collectPowerUp, null, this);
    this.physics.add.collider(this.rabbit.sprite, this.obstacles, this.obstacleHit, null, this);

    this.createDespawnZone();
    this.createAutoCollectZone();

    this.startObjectSpawning();
  }

  createDespawnZone()
  {
    this.despawnZone = this.add.zone(this.despawnLocation.x, 0, 1, this.sys.game.config.height);
    this.physics.world.enable(this.despawnZone);
    this.despawnZone.body.allowGravity = false;
    this.despawnZone.body.setImmovable(true);
    this.physics.add.overlap(this.despawnZone, this.carrots, (zone, carrot) => { this.removeOutOfBoundObject(zone, carrot); this.carrotsMissed++ }, null, this);
    this.physics.add.overlap(this.despawnZone, this.obstacles, (zone, obstacle) => { this.removeOutOfBoundObject(zone, obstacle); this.obstaclesAvoided++; }, null, this);
    this.physics.add.overlap(this.despawnZone, this.powerUps, (zone, powerUp) => { this.removeOutOfBoundObject(zone, powerUp); this.powerUpsMissed++; }, null, this);
  }

  createAutoCollectZone()
  {
    this.autoCollectZone = this.add.zone(this.rabbit.sprite.x - this.rabbit.sprite.width / 2, 0, this.rabbit.sprite.width * 2, this.sys.game.config.height);
    this.physics.world.enable(this.autoCollectZone);
    this.autoCollectZone.body.allowGravity = false;
    this.autoCollectZone.body.setImmovable(true);
    this.physics.add.overlap(this.autoCollectZone, this.carrots, this.magnetCollectCarrot, null, this);
  }

  startObjectSpawning()
  {
    // Carrots spawn on fixed time
    this.carrotSpawnTimer = this.time.addEvent({ delay: this.carrotSpawnRate, callback: this.spawnCarrot, callbackScope: this, loop: true });
    // Obstacles randomly spawn
    this.spawnObstacle();
    // Power-ups randomly spawn
    this.queuePowerUp(Phaser.Math.Between(this.powerUpSpawnRate.min, this.powerUpSpawnRate.max));
  }

  update(time, delta)
  {
    if(this.rabbit.alive && !this.paused)
    {
      this.updateCarrotsPosition(time, delta);
      this.updateObstaclesPosition(time, delta);
      this.updatePowerUpsPosition(time, delta);

      this.updateTweens();
    }
  }

  updateInput({ cursors, spaceKey, pointerDown })
  {
    const { upKey } = cursors;

    if(this.rabbit.isTouchingGround())
    {
      this.rabbit.startRunning();
    }
    else if(this.rabbit.isFalling())
    {
      this.rabbit.fall();
    }

    if(this.rabbit.jumping)
    {
      this.rabbit.updateShadow();
    }

    var jumpKeyDown = Phaser.Input.Keyboard.JustDown(upKey) || Phaser.Input.Keyboard.JustDown(spaceKey) || pointerDown;

    if(jumpKeyDown && this.rabbit.isTouchingGround())
    {
      this.rabbit.jump(pointerDown);
    }
  }

  removeOutOfBoundObject(despawnZone, object)
  {
    object.destroy();
  }

  spawnObstacle()
  {
    if(this.spawnAllowed)
    {
      this.obstacleSpawnTimer = null;
      const lastObstacle = this.obstacles.getLast(true);

      if(lastObstacle === null || (lastObstacle.x + lastObstacle.width + this.minObstacleSpacing) <= this.spawnLocation.x)
      {
        const newObstacle = this.addRandomObstacle(this.spawnLocation.x, this.spawnLocation.y);
        const lastCarrot = this.carrots.getLast(true);

        if(newObstacle !== null && lastCarrot !== null)
        {
          this.physics.world.overlap(lastCarrot, newObstacle, this.onCarrotObstacleOverlap, null, this);
        }

        this.queueObstacle(Phaser.Math.Between(this.obstacleSpawnRate.min, this.obstacleSpawnRate.max));
      }
    }
  }

  queueObstacle(time)
  {
    if(this.obstacleSpawnTimer === null)
    {
      this.obstacleSpawnTimer = this.time.addEvent({ delay: time, callback: this.spawnObstacle, callbackScope: this, loop: false });
    }
  }

  spawnCarrot()
  {
    if(this.spawnAllowed)
    {
      const lastCarrot = this.carrots.getLast(true);

      if(lastCarrot === null || (lastCarrot.x + lastCarrot.width + this.minCarrotSpacing) <= this.spawnLocation.x)
      {
        var newCarrot = this.addCarrot(this.spawnLocation.x, null, this.rabbit.hasRocketCake());
        const lastObstacle = this.obstacles.getLast(true);
        const lastPowerUp = this.powerUps.getLast(true);

        if(newCarrot !== null)
        {
          if(lastObstacle !== null)
          {
            this.physics.world.overlap(newCarrot, lastObstacle, this.onCarrotObstacleOverlap, null, this);
          }

          if(lastPowerUp !== null)
          {
            this.physics.world.overlap(newCarrot, lastPowerUp, this.onCarrotPowerUpOverlap, null, this);
          }
        }
      }
    }
  }

  onCarrotObstacleOverlap(carrot, obstacle)
  {
    this.addCarrot(carrot.x, Phaser.Math.Between(1, 2), carrot.doubleValue);
    carrot.destroy();
  }

  onCarrotPowerUpOverlap(carrot, powerUp)
  {
    powerUp.x += carrot.width * 3;
    powerUp.body.x += carrot.width * 3;

    const lastCarrot = this.obstacles.getLast(true);
    if(lastCarrot !== null)
    {
      this.physics.world.overlap(carrot, powerUp, this.onCarrotPowerUpOverlap, null, this);
    }
  }

  spawnPowerUp()
  {
    this.powerUpSpawnTimer = null;

    if(this.spawnAllowed)
    {
      const lastPowerUp = this.powerUps.getLast(true);

      // Don't spawn powerUps when there is still a powerUp active
      if(this.rabbit.powerUp === null && lastPowerUp === null)
      {
        var newPowerUp = this.addRandomPowerUp(this.spawnLocation.x, Phaser.Math.Between(this.sys.game.config.height - 500, this.sys.game.config.height - 330));
        const lastCarrot = this.obstacles.getLast(true);

        if(newPowerUp !== null && lastCarrot !== null)
        {
          this.physics.world.overlap(lastCarrot, newPowerUp, this.onCarrotPowerUpOverlap, null, this);
        }
      }
    }

    this.queuePowerUp(Phaser.Math.Between(this.powerUpSpawnRate.min, this.powerUpSpawnRate.max));
  }

  queuePowerUp(time)
  {
    if(this.powerUpSpawnTimer === null)
    {
      this.powerUpSpawnTimer = this.time.addEvent({ delay: time, callback: this.spawnPowerUp, callbackScope: this, loop: false });
    }
  }

  updateCarrotsPosition(time, delta)
  {
    this.updateGroupPosition(time, delta, this.carrots);
  }

  updateObstaclesPosition(time, delta)
  {
    this.updateGroupPosition(time, delta, this.obstacles);
  }

  updatePowerUpsPosition(time, delta)
  {
    this.updateGroupPosition(time, delta, this.powerUps);
  }

  updateGroupPosition(time, delta, group)
  {
    var that = this;
    if(group !== null)
    {
      group.children.iterate(function(child)
      {
        if(!child.attracted)
        {
          // child.body.x -= that.trackSpeed;
          child.body.x -= (that.trackSpeed * delta);
        }
      });
    }
  }

  updateTweens()
  {
    this.carrots.children.iterate(function(child)
    {
      if(child.attracted && child.attractTween !== null)
      {
        child.attractTween.updateTo("y", this.rabbit.sprite.y);
      }
    }, this);
  }

  createRabbit(x = 0, y = x)
  {
    if(this.rabbit !== null)
    {
      this.rabbit.destroy();
    }

    this.rabbit = new Rabbit(this, x, y);

    // http://labs.phaser.io/index.html?dir=depth%20sorting/&q=
    // this.children.bringToTop(this.rabbit.sprite);
    this.rabbit.sprite.setDepth(79);

    return this.rabbit;
  }

  addCarrot(x, position, doubleValue)
  {
    var y = this.sys.game.config.height;

    if(typeof position === "undefined" || position === null)
    {
      position = Phaser.Math.Between(0, 2);
    }

    switch(position)
    {
      case 2:
        y -= 500;
        break;
      case 1:
        y -= 330;
        break;
      case 0:
      default:
        y -= 160;
        break;
    }

    var _carrot = new Carrot(this, x, y, position, doubleValue);

    // If carrot is not yet in the scene you can use this instead (true means it will also add the carrot to the scene instead of just the group)
    // No need to worry about this atm since adding to the scene is done automatically in the 'consumable' parent class
    // this.carrots.add(carrot, true);
    this.carrots.add(_carrot);

    _carrot.body.allowGravity = false;
    _carrot.setDepth(49);
    // Using update function to manually move carrots instead. Not really sure about the the velocity since it relies
    // on the fps (atm hardcoded 60) which means that if the fps changes the carrots would start moving faster than the track
    // _carrot.body.velocity.x = -this.trackSpeed * 60;

    return _carrot;
  }

  addRandomObstacle(x = 0, y = x)
  {
    var index = Phaser.Math.Between(0, CONSTANTS.OBSTACLES.length - 1);
    var obstacleFrame = CONSTANTS.OBSTACLES[index];

    var _obstacle = new Obstacle(this, x, y, CONSTANTS.ATLAS_KEY, obstacleFrame);

    this.obstacles.add(_obstacle);

    _obstacle.body.allowGravity = false;
    _obstacle.setDepth(39);
    // Immovable is needed here even because the rabbit can still move it by jumping on top of the obstacle
    _obstacle.body.setImmovable(true);
    _obstacle.body.setSize(_obstacle.width * 0.9, _obstacle.height * 0.9, true);
    // Not used atm (see `addCarrot` for reason)
    // _obstacle.body.velocity.x = -this.trackSpeed * 60;

    return _obstacle;
  }

  addRandomPowerUp(x = 0, y = x)
  {
    var index = Phaser.Math.Between(0, CONSTANTS.POWER_UPS.length - 1);

    var _powerUp = new PowerUp(this, x, y, CONSTANTS.POWER_UPS[index]);

    this.powerUps.add(_powerUp);

    _powerUp.body.allowGravity = false;
    _powerUp.body.setImmovable(true);
    _powerUp.setDepth(50);
    // Not used atm (see `addCarrot` for reason)
    // _powerUp.body.velocity.x = -this.trackSpeed * 60;

    return _powerUp;
  }

  collectCarrot(rabbit, carrot)
  {
    carrot.destroy();
    this.events.emit("carrot-taken", carrot);
  }

  magnetCollectCarrot(zone, carrot)
  {
    if(this.rabbit.powerUp !== null && this.rabbit.powerUp.type === "magnet" && !carrot.attracted)
    {
      carrot.attracted = true;
      carrot.attractTween = this.tweens.add({
        targets: carrot,
        x: this.rabbit.sprite.x,
        y: this.rabbit.sprite.y,
        ease: "Sine.easeIn",
        duration: 250
      });
    }
  }

  obstacleHit(rabbit, obstacle)
  {
    if(this.rabbit.powerUp && this.rabbit.powerUp.type === "shield")
    {
      return;
    }

    this.rabbit.alive = false;
    this.rabbit.flash();
    this.events.emit("rabbit-collided");
  }

  collectPowerUp(rabbit, powerUp)
  {
    // this.rabbit != rabbit (rabbit is sprite from this.rabbit)
    this.rabbit.givePowerUp(powerUp);

    this.powerUpTimer = this.time.addEvent({ delay: powerUp.duration, callback: function ()
    {
      this.rabbit.removePowerUp();
      powerUp.destroy();
      this.powerUpTimer = null;
    }, callbackScope: this, loop: false });

    powerUp.disableBody(true, true);
  }

  get paused()
  {
    return this._paused;
  }

  set paused(paused)
  {
    this._paused = paused;

    this.pauseTimers(this.paused);
    this.spawnAllowed = !this.paused;

    if(this.paused)
    {
      this.physics.pause();

      if(this.rabbit !== null)
      {
        this.rabbit.sprite.anims.stop();
      }
    }
    else
    {
      this.physics.resume();

      if(this.rabbit !== null)
      {
        this.rabbit.sprite.anims.play();
      }
    }
  }

  pauseTimers(flag)
  {
    this.pauseTimer(this.obstacleSpawnTimer, flag);
    this.pauseTimer(this.carrotSpawnTimer, flag);
    this.pauseTimer(this.powerUpSpawnTimer, flag);
    this.pauseTimer(this.powerUpTimer, flag);
  }

  pauseTimer(timer, flag)
  {
    if(timer)
    {
      timer.paused = flag;
    }
  }

  clearTrack()
  {
    this.rabbit.destroy();

    this.autoCollectZone.destroy();
    // Params: removeFromScene, destroyChild
    this.carrots.clear(true, true);
    this.obstacles.clear(true, true);
    this.powerUps.clear(true, true);
  }
}



// WEBPACK FOOTER //
// ./app/js/games/carrot-game/scenes/track.js